<template>
    <section class="game-result"
        :class="{
            'history-mode': type == 'history',
            'be-center': (type == 'history' && aRoundList.length <= 5),
        }"
        :ref="el=>oListWrap=el"
    >
        <div class="one-step"
            v-for="(cur, idx) of aRoundList"
            :key="idx"
            @click="clickOnStep(idx)"
            :class="{
                active: idx === iActive,
                skip: cur.skip,
            }"
        >
            <!-- ↓ 历史窗口专用 -->
            <template v-if="type==='history'">
                <mark class='head-words'  >
                    {{ 
                        (idx === 0)
                        ? $t('hilo.1stCard')
                        : cur.odd.toFixed(3)
                    }}
                </mark>
                <i class='bottom-narrow' />
            </template>
            <!-- ↑ 历史窗口专用 -->
            <i v-if="idx > 0"
                class="narrow"
                :class="{down: cur.ac == 2}"
            >
                <IconSvgUse
                    v-if="cur.skip"
                    size="10px"
                    use="circle-narrow"
                />
                <IconSvgUse 
                    v-else
                    size="22px"
                    file-name="hilo"
                    :use="cur.hasLost_ ? 'hilo-narrow-red' : 'hilo-narrow-green'"
                />
            </i>
            <!-- ↑箭头 ↓卡牌  -->
            <Poker :iCardNo="cur.card"/>
        </div>
    </section>
</template>

<script lang="ts" setup>
import {computed} from 'vue';
import Poker from './poker.vue';
import {deepCopy} from '@/utils/toolFn';

const props = defineProps({
    aRoundList: {
        type: Array,
        required: true,
    },
    oGameInfo: {
        type: Object,
        default: () => ({}),
    },
    type: String, // 值为 history 表示当前组件用于展示历史记录 
}); 

const iActive = ref(0);
const oListWrap = ref(null);

const aRoundList = computed(()=>{
    const hasLost = props.oGameInfo.status === 'lose';
    const aTheArr001 = deepCopy(props.aRoundList || []);  
    const arr = aTheArr001.filter(cur => {
        // ↓ 没有 hash 的是用户押注前创建的  
        return !!(cur as any).hash;
    }).map((cur, idx) => {
        return {
            ...cur,
            skip: idx > 0 && ![1,2].includes(cur.ac),
        };
    });
    const oLast = arr.at(-1);
    if (hasLost && oLast) {
        oLast.hasLost_ = true;
    }
    return arr;
});

const oConfig = {
    immediate: true,
    deep: true,
};


const fnUpdateFairness = inject('fnUpdateFairness');

function clickOnStep(idx){
    if (props.type != 'history') return;
    iActive.value = idx; 
    const oStep = props.aRoundList[idx] as any;
    if (fnUpdateFairness){
        (fnUpdateFairness as any)(oStep); 
    }
}

if (props.type == 'history') {
    watch(() => props.oGameInfo._id, (newId)=>{
        // ↓ 页码归零 
        clickOnStep(0);
    }, oConfig);
} else { 
    // ↓ 用于实时地滚动到最右侧  
    watch(() => props.aRoundList.length, (iCardlength)=>{
        moveToRight(iCardlength)
    }, oConfig);
}


// 移动到最右侧
function moveToRight(iCardlength){
    nextTick(()=>{
        if (!oListWrap.value) return;
        // ↓ 500 足够宽了
        const iGoTo = iCardlength * 500;
        oListWrap.value.scrollLeft = iGoTo;
    }); 
}

// 移动到最右侧
onMounted(()=>{
    if (props.type == 'history'){
        moveToRight(props.aRoundList.length);
    }
});

</script>


<style scoped lang="scss">
// 👇结果区
.game-result{
    // margin-top: 40px;
    // padding-bottom: 5px;
    // ↑ 注释掉，由调用方指定 
    display: flex;
    max-width: 100%;
    overflow-x: auto;
    & > .one-step:last-child{
        margin-right: auto;
    }
    .one-step{
        display: flex;
        align-items: center;
        align-content: center;
        &.skip{
            .poker{
                filter: brightness(0.7);
            }
        }
    }
    .narrow{
        background-color: #161f2c;
        border: 1px solid rgba(85,101,126,.28);
        border-radius: 10px;
        box-shadow: 0 4px 8px rgba(13,19,28,.67);
        display: flex;
        justify-content: center;
        align-items: center;
        height: 27px;
        width: 27px;
        z-index: 2;
        margin: 0 -8px;
        &[class~=down]{
            transform: rotate(180deg);
        }
    }
}

// ↓历史窗口专用 
.game-result.history-mode{
    --my-green: #0BB85A;
    padding-inline: 3px !important;
    .one-step{
        position: relative;
        padding-top: 25px !important;
        padding-bottom: 23px;
        &:first-child{ 
            .head-words{
                padding: 0;
            }
        }
        .head-words{
            position: absolute;
            display: block;
            width: 100%;
            padding-left: 10px; 
            top: 0;
            left: 0;
            overflow: hidden;
            text-align: center; 
            color: var(--my-green);
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 12px;
            font-weight: 700;
            background: transparent;
        }
        .bottom-narrow{
            height: 0;
            width: 0; 
            position: absolute;
            bottom: -12px;
            right: 8px; 
            border: 12px solid rgba(255, 184, 90, 0); 
            border-top-color: var(--my-green); 
            pointer-events: none; 
            display: none; 
        }
        .poker{
            cursor: pointer;
            transition: all 0.2s; 
        }
        &.active{
            .poker{
                box-shadow: 0px 0px 0px 3px var(--my-green);
            }
            .bottom-narrow{
                display: block;
            }
        }
    }
}

.history-mode.be-center{
    justify-content: center;
    align-items: center;
    .one-step{
        margin-right: 0;
    }
}

</style>


